export class AiRequestData{
    message?: string;    
}
export class AiReadFile{
    folderPath?: string;
    fileName?: string;
}